import Rest from '@/services/Rest';

/**
 * @typedef {SubUsersPermissions}
 */
export default class SubUsersPermissions extends Rest {
  /**
   * @type {String}
   */
  static resource = '/sub-user-permissions'
}